"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _api = require("./api");
var _Toggle = require("../../../components/Toggle");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ClinicianPaidToBy = function ClinicianPaidToBy(_ref) {
  var _ref$clinicianId = _ref.clinicianId,
    clinicianId = _ref$clinicianId === void 0 ? 'me' : _ref$clinicianId;
  var _useUpdateClinicianPa = (0, _api.useUpdateClinicianPaidTo)(clinicianId),
    paidTo = _useUpdateClinicianPa.paidTo,
    loading = _useUpdateClinicianPa.loading,
    updatePaidToByMonument = _useUpdateClinicianPa.updatePaidToByMonument;
  if (paidTo && !loading) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "max-w-[700px] flex justify-start"
  }, /*#__PURE__*/_react.default.createElement(_Toggle.Toggle, {
    checked: paidTo,
    loading: loading,
    onChange: updatePaidToByMonument
  }));
};
var _default = ClinicianPaidToBy;
exports.default = _default;